// ===== 2. React Hook for AI Recommendations =====
// src/hooks/useAISubcodeRecommendations.ts

import { useState, useEffect } from 'react';
import { AISubcodeRecommendationService, AIRecommendationResponse } from './aiSubcodeRecommendationService';

export const useAISubcodeRecommendations = (formData: any) => {
  const [recommendations, setRecommendations] = useState<AIRecommendationResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Only fetch recommendations when we have the required data
    if (!formData?.PurposeType || !formData?.PropertyUseType || !formData?.PropertyType) {
      setRecommendations(null);
      return;
    }

    const fetchRecommendations = async () => {
      setLoading(true);
      setError(null);

      try {
        const aiService = new AISubcodeRecommendationService();
        const result = await aiService.getSubcodeRecommendations(formData);
        setRecommendations(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to get recommendations');
      } finally {
        setLoading(false);
      }
    };

    // Debounce API calls to avoid too many requests
    const timeoutId = setTimeout(fetchRecommendations, 1000);
    return () => clearTimeout(timeoutId);

  }, [formData]);

  return { recommendations, loading, error };
};
